import { render, staticRenderFns } from "./FieldTypeBoolean.vue?vue&type=template&id=dcd9e750&"
import script from "./FieldTypeBoolean.vue?vue&type=script&lang=ts&"
export * from "./FieldTypeBoolean.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports